var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgAdopt({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "24px",
    height: "24px",
    viewBox: "0 0 24 24",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    stroke: "none",
    strokeWidth: 1,
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M21,7 L21,20 C21,21.1 20.1,22 19,22 L9,22 C7.89,22 7,21.1 7,20 L7,7 C7,5.89 7.89,5 9,5 L12,5 L12,7 L9,7 L9,20 L19,20 L19,7 L12,7 L12,5 L19,5 C20.1,5 21,5.89 21,7 Z",
    id: "Path"
  }), /*#__PURE__*/React.createElement("polygon", {
    id: "Path",
    transform: "translate(14.000000, 13.500000) rotate(180.000000) translate(-14.000000, -13.500000) ",
    points: "18 12 16.58 13.42 14.99 11.83 14.99 19 13.01 19 13.01 11.83 11.42 13.42 10 12 14 8"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M4,3 L2,3 L2,5 L2.01,5 L2,14 C2,15.1 2.9,16 4,16 L17,16 L17,14 L4,14 L4,3 Z",
    id: "Shape",
    transform: "translate(9.500000, 9.500000) rotate(90.000000) translate(-9.500000, -9.500000) "
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgAdopt);
export default __webpack_public_path__ + "static/media/adopt.b05300c47cb49dff0cd16f81a52f383b.svg";
export { ForwardRef as ReactComponent };